<template>
    <v-dialog
        v-if="visible"
        v-model="visible"
        transition="dialog-top-transition"
        scrollable
        persistent
        max-width="700"
    >
        <v-card class="modal-maincard">

            <v-toolbar dark flat dense>
                <v-toolbar-title>{{ $t(title) }}</v-toolbar-title>
            </v-toolbar>

            <v-card-text class="wrapperFormModal">
                        
                <v-card
                    flat
                >
                    <v-card-text>
<!--
                        <v-row no-gutters>
                            <v-col cols="12" sm="12" md="4">
                                <label class="f-label">{{ $t("Территориальная_единица") }}</label>
                            </v-col>
                            <v-col  cols="12" sm="12" md="8">
                                <v-autocomplete
                                    :items="regions"
                                    v-model="regionId"
                                    item-text="name"
                                    item-value="id"
                                    required
                                    outlined
                                    dense
                                    append-icon="fas fa-chevron-down"
                                    :readonly="regions.length == 1"
                                >
                                </v-autocomplete>
                            </v-col>
                        </v-row>
-->
                        <v-row no-gutters>
                            <v-col cols="12" sm="12" md="3">
                                <label class="f-label">{{ $t("Фйл с данными") }}</label>
                            </v-col>
                            <v-col cols="12" sm="12" md="9">
                                <div class="icon-click-row-group">

                                    <div @click="$refs.dataFileSelect.click()">
                                        <input
                                            type="file"
                                            accept=".xlsx"
                                            ref="dataFileSelect"
                                            @change="onFilePOChange"
                                            style="display: none"
                                        />
                                        <v-icon small>
                                            fas fa-edit
                                        </v-icon>
                                    </div>
                                    <div class="cloud-file-list-box">
                                        <div class="cloud-items-container">
                                            <div v-if="!dataFile" class="cfl-placeholder">{{ $t('Не_выбран_файл') }}</div>
                                            <v-row 
                                                v-else
                                                dense
                                            >
                                                <v-file-item
                                                    :name="dataFile.name"
                                                    :size="dataFile.size"
                                                    col-width="4"
                                                    :hide-load="true"
                                                    @on-delete-attachment="onDeletePO()"
                                                />
                                        </v-row>
                                        </div>
                                    </div>                
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn 
                    color="cyan"
                    text
                    depressed
                    @click="ok"
                    v-if="isOkVisible"
                >
                    {{ $t("Загрузить") }} 
                </v-btn>

                <v-btn
                    color="blue-grey"
                    text
                    depressed
                    @click="cancel"
                >
                    {{ $t("Отмена") }}
                </v-btn>

            </v-card-actions>

        </v-card>
    </v-dialog>
</template>

<script>

export default {
    name: "ImportClassifierDlg",
    data () {
        return {
            title: 'Импорт_классификатора',
            options: {
                color: 'grey lighten-3',
                width: 400,
                zIndex: 200,
                noconfirm: false,
            },
            visible: false,
            loading: false,
            dataFile: null,
            resolve: null,
            reject: null,
        }
    },
    computed: {
        isOkVisible() {
			return this.dataFile != null;			
        }
    },
    methods: {
        async open(){
            this.dataFile = null;
            this.visible = true;
            return new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });
        },
        async ok(){
            this.visible = false;
            this.resolve({ dataFile: this.dataFile });
        },
        async cancel(){
            this.visible = false;
            this.reject({ message: 'Cancelled' });
        },
        async onFilePOChange (event) {
            let files = Array.from(event.target.files);            
            if (files.length > 0){
                this.dataFile = files[0];
                event.target.value = '';
            }
        },
        onDeletePO() {
            this.dataFile = null;
        },
    }
}
</script>